/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Flex, Text, Image, Button, Divider } from "@aws-amplify/ui-react";
import QualifiedImage from "../assets/qualified.png"; // Import Qualified image
import SoftwarePartnerImage from "../assets/softwarepartner.png"; // Import Software Partner image
import AvailableInMarketplaceImage from "../assets/AvailableInMarketplace_Gray850_RGB.png"; // Import Marketplace image

const CustomFooter = (props) => {
  const { overrides, ...rest } = props;

  const newsletter = {
    container: {
      backgroundColor: "#F9F9F9",
      flexDirection: "column",
      alignItems: "center",
      padding: "20px",
      marginTop: "35px",
      paddingBottom: "30px",
      fontFamily: "Arial, sans-serif",
      fontSize: "14px",
      color: "#333",
    },
    content: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      width: "100%",
      maxWidth: "1200px",
      marginTop: "20px",
      gap: "20px",
    },
    column: {
      flex: "1",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    form: {
      display: "flex",
      alignItems: "center",
      marginTop: "20px",
    },
    input: {
      padding: "10px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      marginRight: "10px",
      fontSize: "1.1em",
      width: "300px",
      outline: "none",
    },
    button: {
      padding: "10px 20px",
      border: "1px solid rgb(204, 204, 204)",
      backgroundColor: "#FFF",
      color: "#000",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "1.1em",
      fontWeight: "bold",
    },
    footer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      marginTop: "40px",
      paddingLeft: "50px",
      paddingRight: "50px",
      paddingBottom: "20px",
      paddingTop: "10px",
    },
    logo: {},
    logoImage: {
      height: "40px",
      marginRight: "5px",
    },
    copyright: {
      fontSize: "1.1em",
      color: "#777",
    },
    imageRow: {
      display: "flex",
      flexDirection: "row", // Ensures images are side by side
      gap: "20px", // Adds spacing between images
      justifyContent: "center",
      alignItems: "center",
    },
    image: {
      width: "125px", // Reduced size by 50%
      height: "auto",
    },
  };

  return (
    <Flex
      style={newsletter.container}
      {...getOverrideProps(overrides, "NewsletterContainer")}
    >
      <Divider
        width="94.5%"
        marginTop="20px"
        {...getOverrideProps(overrides, "Divider")}
      />

      {/* Two columns: one for email and text, one for images */}
      <Flex style={newsletter.content}>
        {/* Column 1: Email form and text */}
        <Flex style={newsletter.column}>
          <Text
            color="#304050"
            fontSize="1.3em"
            fontWeight="bold"
            {...getOverrideProps(overrides, "NewsletterTitle")}
          >
            Sign up for our newsletter
          </Text>
          <Text
            paddingTop="5px"
            fontSize="1.2em"
            {...getOverrideProps(overrides, "NewsletterSubtitle")}
          >
            No spam. We promise.
          </Text>
          <form style={newsletter.form} {...getOverrideProps(overrides, "NewsletterForm")}>
            <input
              type="email"
              placeholder="Your email"
              style={newsletter.input}
              {...getOverrideProps(overrides, "NewsletterInput")}
            />
            <Button
              type="submit"
              style={newsletter.button}
              {...getOverrideProps(overrides, "NewsletterButton")}
            >
              Subscribe
            </Button>
          </form>
        </Flex>

        {/* Column 2: Images */}
        <Flex style={newsletter.imageRow}>
          <Image
            src={QualifiedImage}
            alt="Qualified"
            style={newsletter.image}
            {...getOverrideProps(overrides, "QualifiedImage")}
          />
          <Image
            src={SoftwarePartnerImage}
            alt="Software Partner"
            style={newsletter.image}
            {...getOverrideProps(overrides, "SoftwarePartnerImage")}
          />
          <a
            href="https://aws.amazon.com/marketplace/pp/prodview-epowjzdmfmli6?trk=176b570f-20dd-4b84-aa7e-cae53990fe91&sc_channel=el&source=gaiiff"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image
              src={AvailableInMarketplaceImage}
              alt="Available in AWS Marketplace"
              style={newsletter.image}
              {...getOverrideProps(overrides, "AvailableInMarketplaceImage")}
            />
          </a>
        </Flex>
      </Flex>

      <Flex
        style={{ ...newsletter.footer, alignItems: "center", justifyContent: "space-between" }}
        {...getOverrideProps(overrides, "NewsletterFooter")}
      >
        <Flex
          style={{ ...newsletter.logo, flexDirection: "column", alignItems: "flex-start" }}
          {...getOverrideProps(overrides, "NewsletterLogo")}
        ></Flex>
        <Text
          style={{ ...newsletter.copyright, alignSelf: "flex-end" }}
          {...getOverrideProps(overrides, "NewsletterCopyright")}
        >
          © 2021-2025 Aitium®. All rights reserved.
        </Text>
      </Flex>
    </Flex>
  );
};

export default CustomFooter;